export const PROFILE_TYPE = {
    SUPER_ADMIN: 'principal',
    ADMIN: 'teacher',
}